'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "InlineGrid": "Polaris-InlineGrid"
};

exports.default = styles;
